import React, { FC, memo } from 'react';
import useTranslations from '@hooks/useTranslations';
import Link from '../CustomNextLink';
import { IImageButtonProps } from './ImageButton';
import Icon, { Icons } from '../Icon';
import { usePxPendingUploads } from '@hooks/usePxPendingUploads';
import { useTheme } from '@hooks/useTheme';

interface IImageLinkProps {
    isActive: boolean;
    children: React.ReactNode;
    href: string;
}

const ImageLink: FC<IImageLinkProps> = memo(({ isActive, children, href }: IImageLinkProps) => {
    if (isActive) {
        return (
            <Link href={href}>
                <a className="img-btn-container active">{children}</a>
            </Link>
        );
    }

    return <span className="img-btn-container inactive">{children}</span>;
});
ImageLink.displayName = 'ImageLink';

export const ImageButtonTemplate: FC<IImageButtonProps> = memo(
    ({ href, className, imgUrl, title, description, counter, usePxNotification, alt }) => {
        const theme = useTheme();
        const { t } = useTranslations();
        const isActive: boolean = counter > 0;

        const { pxPendingUploads } = usePxPendingUploads();
        const hasPendingPxUploads = usePxNotification && pxPendingUploads.length > 0;

        return (
            <div className={className}>
                <ImageLink isActive={isActive} href={href}>
                    <div className="top">
                        <h1>{t(title)}</h1>
                        {isActive && <p className="sum">{counter}</p>}

                        {hasPendingPxUploads && (
                            <Icon
                                height={24}
                                name={Icons.InfoCircle}
                                className={`pxAttention`}
                                color={theme.colors.white}
                            />
                        )}
                    </div>
                    <img src={imgUrl} alt={alt} />
                    {hasPendingPxUploads && <div className="pxAttentionLabel">{t('pxUploadLabel')}</div>}
                    <p className="description">{t(description)}</p>
                </ImageLink>
            </div>
        );
    }
);
ImageButtonTemplate.displayName = 'ImageButtonTemplate';
